import React, { useCallback } from 'react';

interface SourceSet {
  source: string;
  descriptor?: string;
}
type CrossOrigin = 'anonymous' | 'use-credentials' | '' | undefined;

export interface ImageProps extends React.HTMLProps<HTMLImageElement> {
  alt: string;
  src: string;
  crossOrigin?: CrossOrigin;
  sourceSet?: SourceSet[];
  onLoad?(): void;
  onError?(): void;
}

export interface WpImageProps extends ImageProps {
  className?: string;
}

const WpImage = ({ src, sourceSet, crossOrigin, alt, onLoad, onError, className, ...rest }: ImageProps) => {
  const finalSourceSet = sourceSet
    ? sourceSet.map(({ source: subSource, descriptor }) => `${subSource} ${descriptor}`).join(',')
    : null;

  const handleOnLoad = useCallback(() => {
    if (onLoad) onLoad();
  }, [onLoad]);

  const handleOnError = useCallback(() => {
    if (onError) onError();
  }, [onError]);

  return (
    <img
      alt={alt}
      src={src}
      crossOrigin={crossOrigin}
      className={className}
      onLoad={handleOnLoad}
      onError={handleOnError}
      {...(finalSourceSet ? { srcSet: finalSourceSet } : {})}
      {...rest}
    />
  );
};

export default WpImage;
